export function agendaSidebarDateFormat(date) {
    const day = date.getUTCDate();
    const month = date.getMonth();
    const year = date.getFullYear();
    const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    return `${months[month]} ${day} de ${year}`;
}

export function agendaHourPickerDateFormat(date) {
    const day = date.getUTCDate();
    const month = date.getMonth();
    const weekday = date.getDay();
    const weekdays = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
    const months = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
    return `${weekdays[weekday]}, ${months[month]} ${day}`;
}

export function agendaResumeDateFormat(date) {
    const day = date.getUTCDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    return `${months[month - 1]} ${day} de ${year}`;
}

export function schedulingDateFormat(date) {
    const day = date.getUTCDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
}

export function agendaSidebarHourFormat(hour) {
    let parts = hour.split(":");
    let hours = parseInt(parts[0]);
    let minutes = parseInt(parts[1]);
    let suffix = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    if (hours === 0) { hours = 12; }
    minutes = minutes < 10 ? "0" + minutes : minutes;
    return hours + ":" + minutes + " " + suffix;
}

export function alertDateFormat(inputDate) {
    const dateObject = new Date(inputDate);
    const day = dateObject.getUTCDate();
    const month = dateObject.getMonth() + 1;
    const year = dateObject.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate;
}

export function numberDateFormat(inputDate) {
    if (inputDate === '') {
        return '';
    }
    const dateObject = new Date(inputDate);
    const day = dateObject.getUTCDate();
    const month = dateObject.getMonth() + 1;
    const year = dateObject.getFullYear();
    const dayFormat = `${day}`.length > 1 ? day : `0${day}`;
    const monthFormat = `${month}`.length > 1 ? month : `0${month}`;
    const formattedDate = `${dayFormat}/${monthFormat}/${year}`;
    return formattedDate;
}


export function formateDateToDayNumberDayMonthAndYear(date) {
    const day = date.getUTCDate();
    const month = date.getMonth();
    const year = date.getFullYear();
    const weekDay = date.getDay()
    const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    const days = ["Domingo","Lunes","Martes","Miercoles","Jueves","Viernes","Sabado"]
    return `${days[weekDay]}, ${day} de ${months[month]} ${year}`;
}

export function formatDateMongo(date) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
}

export function formatHourMongo(date) {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
}


